import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceTabFour() {
    return (
        <Container>
            <Row style={{ justifyContent: 'center' }} >
                <Row className='mt-3'>
                    <Col className='service_des_title' > DOOR/DOORBELL CAMERAS </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <p className='service_des_p' >
                            A smart door camera is an internet-connected doorbell that notifies the smartphone or other electronic device of the homeowner when a visitor arrives at the door. It activates when a person presses the button of the doorbell, or when the doorbell senses a person with its built-in motion sensors.
                        </p>
                        <p className='service_des_p'>
                            Door cameras work the same way as security cameras, capturing video, either during the day or at night via infrared LED sensors or a spotlight, and audio through a speaker and microphone. The data is stored either in a built-in microSD card or remotely through a cloud server.
                        </p>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_title'> We Are Your Answer to All Things Security  </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_p' >
                        <p className='service_des_p'> In this digitalized era, we are one of the best doorbell camera dealers in Hyderabad, offering you top-notch security systems at an affordable range. Our door camera service provides-</p>
                        <ul>
                            <li>Security At Your Doorstep</li>
                            <li>Security even when you aren't at home (You can witness everything through the doorbell camera)</li>
                        </ul>
                        <p className='service_des_p'> Royality Technologies is a pioneer in the surveillance industry in Hyderabad. We are responsible for providing quality products and services with the support of our professional technical staff. Being a major surveillance system brand, we provide efficient, reliable, and integrated solutions to our customers.</p>
                    </Col>
                </Row>
            </Row>
        </Container>
    )
}

export default ServiceTabFour